<!-- skeletons -->
<ng-container *ifLoaded="!!layout || !!message || !!partial; template: 'entity-hub'"></ng-container>

<!-- ad skin -->
<div class="ad-skin d-none d-xl-block">
  <flo-lazy
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'skin'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
</div>


<!-- banner, header & subnav -->
<ng-container *ngIf="layout">
  <!-- only do this geoblock check for a geoblock error banner -->
  <ng-container *ngIf="layout.banner?.type === 'callout' && layout.banner?.style === 'error'">
    <ng-container *ifLoaded="geoBlockedIds; template: ''">
      <ng-container *ngIf="geoBlockedIds.length > 0">
        <div class="position-relative fade-in bg-grey-200">
          <flo-banner-callout [callout]="layout.banner"></flo-banner-callout>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <div class="entity-header-container position-relative bg-white">
    <flo-header
      [header]="layout.header"
      (headerCtaButtonClick)="handleHeaderCtaButtonClick($event)"
    ></flo-header>
  </div>
  <div class="entity-subnav-container position-relative mb-0 bg-white border-top border-bottom">
    <div class="container p-0">
      <flo-nav [nav]="layout.nav" [selectedLink]="selectedTab" tagName="Tab" (navLinkClicked)="handleTabClicked($event)"></flo-nav>
    </div>
  </div>
</ng-container>

<flo-lazy
  [componentConstructor]="AdComponent"
  [initialProps]="adConfigMap | mapGet: 'interstitial'"
  (componentLoaded)="loadedAdsPush($event)"
></flo-lazy>

<!-- main content & right rail -->
<flo-content-right-rail-layout
  [container]="partial?.data || layout?.container"
  [secondaryContainer]="layout?.secondaryContainer"
  [bottomContent]="layout?.bottomContent"
  [isLoading]="isLoading"
  [isPartialError]="isPartialError"
  [hideRightRail]="hideRightRail"
  [message]="message"
  [selectedItem]="selectedItem"
  [geoBlockedIds]="geoBlockedIds"
  [imageWithButtons]="imageWithButtons"
  [description]="description"
  [showFooterCTA]="true"
  (nextPage)="handleNextPage($event)"
  (toggleClicked)="handleToggleClicked($event)"
>
  <flo-lazy
    leaderboard-large
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'leaderboard-large'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
  <flo-lazy
    leaderboard-small
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'leaderboard-small'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
  <flo-lazy
    rectangle-mobile
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'rectangle-mobile'"
    (componentLoaded)="loadedAdsPush($event)"
    [detectorHeight]="125"
  ></flo-lazy>
  <flo-lazy
    content-mobile
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'content-mobile'"
    (componentLoaded)="loadedAdsPush($event)"
    [detectorHeight]="50"
  ></flo-lazy>
  <flo-lazy
    adhesion
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap | mapGet: 'adhesion'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
</flo-content-right-rail-layout>
